import logoTransparent from '../../assets/logo-transparent.png';

interface AppLoaderProps {
	message?: string;
	/** 'fullscreen' shows gradient background, 'inline' shows within the page content */
	variant?: 'fullscreen' | 'inline';
}

const AppLoader = ({ message = 'Loading', variant = 'fullscreen' }: AppLoaderProps) => {
	if (variant === 'inline') {
		return (
			<div className="flex flex-col items-center justify-center py-16">
				<div className="w-20 h-20 mb-6 animate-bounce bg-white rounded-2xl p-2 mx-auto">
					<img
						src={logoTransparent}
						alt="BBP Logo"
						className="w-full h-full object-contain"
					/>
				</div>
				<div className="text-lg text-gray-600 dark:text-gray-300 font-medium">
					{message}
					<span className="app-loader__dots">
						<span>.</span>
						<span>.</span>
						<span>.</span>
					</span>
				</div>
			</div>
		);
	}

	return (
		<div className="app-loader">
			<div className="app-loader__container">
				<div className="app-loader__logo">
					<img
						src={logoTransparent}
						alt="BBP Logo"
						style={{ width: '100%', height: '100%', objectFit: 'contain' }}
					/>
				</div>
				<h1 className="app-loader__title">Beauty Business Portal</h1>
				<p className="app-loader__subtitle">Business Network Management System</p>
				<div className="app-loader__loading">
					{message}
					<span className="app-loader__dots">
						<span>.</span>
						<span>.</span>
						<span>.</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default AppLoader;
